import React, { useEffect } from 'react';
import { useFetch } from '../../utils/hooks/useFetch';
import { ContactUsApi } from '../../api/base/ContactUs';
import { Skeleton } from '@material-ui/lab';
import {Blog } from "./Blog";
import { useParams } from 'react-router';


export const NewsBlock: React.FC = () => {
  const params:any = useParams();
  const [{ response, isLoading }, doFetch] = useFetch(
      ContactUsApi.getSingleNews,
    );
    
    useEffect(() => {
      doFetch(params.id);
    }, [doFetch]);

    console.log("res",response?.data);
    

    return (
        <div>
            {isLoading ? (
              <Skeleton height={444} />
            ) : (
              response?.data?.data && <Blog list={response?.data?.data || []} />            )}
        </div>
    )
}